import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";

import "jquery-deparam";
import "vendor/jquery/effect.highlight";

import "shared/jquery/datepicker";

import View from "backdraft-app/src/view";

import EditableSelectInputView from "shared/controls/editable_select_input_view";
import EditableTextInputView from "shared/controls/editable_text_input_view";

import ActionBar from "./action_table/action_bar";
import DataTableSettingsManager from "./action_table/data_table_settings_manager";
import EditableControls from "./action_table/editable_controls";
import ModalColumnPicker from "./action_table/modal_column_picker";

const ActionTable = View.extend({
  events: {
    "click .table-area tbody td.inline-editable [data-action='edit']": "_onEditClick",
    "click [data-action='edit-columns']": "_onEditColumnsClick"
  },

  template: `
      <div data-mount="action-bar"></div>
      <div class="insert-middle"></div>
      <div class="edit-columns-area clearfix">
        <div class="left">
          <div class="bulk-actions-stats"></div>
        </div>
        <a href="javascript:;" data-action="edit-columns" class="pull-right edit-columns">Edit Columns</a>
        <span data-action="clear-filters-area" class="pull-right ui-hidden"> 
          <span class="divider">|</span> 
          <a href="javascript:;" data-action="clear-filters" class="clear-filters">Clear Filters</a>
        </span>
        <span data-action="reset-sorting-area" class="pull-right ui-hidden"> 
          <span class="divider">|</span> 
          <a href="javascript:;" data-action="reset-sorting">Reset Sorting</a> 
        </span>
      </div>
      <div class="table-area"></div>
    `,

  actionBarClass: ActionBar,

  constructor(options) {
    options || (options = {});
    if (!options.collection) {
      throw new Error("collection must be provided");
    }

    if (options.dataTableClass) {
      this.dataTableClass = options.dataTableClass;
      delete options.dataTableClass;
    }

    if (!this.dataTableClass) {
      throw new Error("dataTableClass must be provided");
    }

    _.bindAll(this, "_updateDataTableAjaxParams");

    if (options.filters) {
      this.filters = options.filters;
    }

    const collection = options.collection;
    delete options.collection;
    this.model = new Backbone.Model(_.extend(_.result(options, "selections") || {},
      this._selectionsFromFragment(options.fragment || Backbone.history.location.search)));
    this.listenTo(this.model, "change", function() {
      this.trigger("change:selections");
    });
    this.persistedDataTableSettings = options.persistedDataTableSettings || {};
    this.pageLength = options.pageLength;
    ActionTable.__super__.constructor.apply(this, arguments);
    this._createActionBar();
    this._createDataTable(collection);
    this.child('dataTable').on("render", this._handleColumnFilterEvents, this);
    this.child('dataTable').on("draw", this._highlightRowIfNecessary, this);
    if (this.child('dataTable').showResetSorting) {
      this.child("dataTable").on("draw", this._displayResetSortingLinkAndEvent, this);
    }

    this._settingsManager = new DataTableSettingsManager(this.child('dataTable'), this.persistedDataTableSettings, { saveOnVisibilityChanges: false });
  },

  enableHorizontalScrolling(fixedElements, elementToScroll) {
    (function(fixedElements, elementToScroll) {
      elementToScroll.addClass('scroll-at-window');

      const GLOBAL_PADDING_WIDTH = 40;
      const GLOBAL_PADDING_SIDE  = GLOBAL_PADDING_WIDTH / 2;

      const headerElement           = $('#header');
      const footerElement           = $('#footer');
      const body                    = $('body');
      const tableAreaElement        = this.child("dataTable").$el.parent();
      const tableElement            = this.child("dataTable").$('table');
      const tableFooterElement      = tableAreaElement.find('.table-footer-controls');
      let canScrollY              = body.get(0).scrollHeight > window.innerHeight;
      const flashRow                = $('.flash-row');
      const skipToContent           = $('a[name="start-of-content"]');
      const navbar                  = $('.navbar');
      let uservoice               = $('.uv-popover');
      const helpIcon                = $('#nav_item_question-sign_js');
      const datePickerInputs        = $('.date-range-selector input').datepicker();
      let datepicker              = $('.datepicker');
      const signalDetails           = $('.signal-details .details');
      const signalTds               = $('td.expandable');
      const $window                 = $(window);
      let scrollDirection         = { x: false, y: false, bypass: false };
      const uniqueHelpText          = $('.unique_help_text');
      const isIE                    = navigator.userAgent.match(/(MSIE|Trident|Edge)/gi);
      let animateFooterInterval;

      // this cleans up any previous scrolling that was set up (to handle the table being re-loaded / re-rendered)
      $(window).trigger('horizontalScrollInitialized');

      positionElementsOnce();
      handleChange();
      positionElementsForHorizontalScrolling();
      addListeners();

      function addListeners() {
        $window.on('horizontalScrollInitialized', disableHorizontalScrolling);
        $window.on('wheel', handleWheel);
        $window.on('scroll', handleChange);
        $window.on('resize', handleChange);
        helpIcon.on('click', handleUserVoice);
        datePickerInputs.on('show', handleDatePicker);
        signalTds.on('click', handleSignalClick);
      }

      function removeListeners() {
        $window.off('horizontalScrollInitialized');
        $window.off('wheel', handleWheel);
        $window.off('scroll', handleChange);
        $window.off('resize', handleChange);
        helpIcon.off('click', handleUserVoice);
        datePickerInputs.off('show', handleDatePicker);
        signalTds.off('click', handleSignalClick);
      }

      function positionElementsOnce() {
        const tableStyle = {
          position: 'relative',
          'z-index': 1
        };

        if (isIE) {
          tableStyle.margin = '0 20px -4px 20px';
          tableStyle.padding = '0px';
          tableStyle.display = 'inline-block';

          window.invocaIE = true;
        }

        tableElement.css(tableStyle);

        // TODO: this should be more automatic based on existing styles / margins on the page
        //       padding bottom of content wrapper must be as high as the footer height
        $('#pageContentWrapper').css('padding-bottom', 130);
      }

      function handleSignalClick() {
        if (animateFooterInterval) {
          clearInterval(animateFooterInterval);
        }

        const signalDrawer = $(this).parents('tr').next('.signal-details');
        const maxInterval  = 2000;

        footerElement.css('transition', '50ms');
        animateFooterInterval = setInterval(() => {
          positionElementsForHorizontalScrolling();
        }, 40);

        signalDrawer.one('transitionend', finishInterval);
        setTimeout(finishInterval, maxInterval);

        function finishInterval() {
          footerElement.css('transition', 'inherit');

          if (animateFooterInterval) {
            clearInterval(animateFooterInterval);
          }

          $window.trigger('resize');
          signalDrawer.one('transitionstart', handleSignalClick);
        }
      }

      function handleWheel(e) {
        scrollDirection = setScrollDirection(e);

        if (scrollDirection.bypass) {
          return true;
        } else if (scrollDirection.y) {
          e.preventDefault();

          const originalY = $window.scrollTop();
          $window.scrollTop(originalY + e.originalEvent.deltaY);
        } else {
          closeOpenObjects();
        }
      }

      function setScrollDirection(e) {
        // we must re-query for dropdowns or modal backdrop since they are appended dynamically

        const bypass = (
          e.ctrlKey ||
          $('.modal-backdrop').css('display') === 'block' ||
          document.activeElement !== document.getElementsByTagName('body')[0] ||
          $('.scrollableList').parents('.dropdown-menu').css('display') === 'block'
        );

        // must calculate both, we can end up with a case of false positive if just checking the opposite of one direction
        let scrollingY;

        let scrollingX;
        if (e.originalEvent.deltaY || e.originalEvent.deltaX) {
          scrollingY = Math.abs(e.originalEvent.deltaY) > Math.abs(e.originalEvent.deltaX);
          scrollingX = Math.abs(e.originalEvent.deltaY) < Math.abs(e.originalEvent.deltaX);
        }

        return { x: scrollingX, y: scrollingY, bypass };
      }

      function positionElementsForHorizontalScrolling() {
        const flashHeight      = flashRow.height();
        const yOffset          = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const xOffset          = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft;
        const aboveTableHeight = headerElement.height() + flashHeight - yOffset;
        const endOfTableHeight = fixedElements.height() + tableAreaElement.height() + aboveTableHeight;
        const footerMarginTop  = 80;
        const paddingSlop      = 15;

        signalDetails.css({
          left: xOffset <= 20 ? 20 : xOffset
        });

        uservoice.css({
          position: 'fixed',
          left: 'inherit',
          right: `${GLOBAL_PADDING_SIDE}px`,
          top: navbar.offset().top + navbar.height() + paddingSlop - yOffset
        });

        flashRow.css({
          left: 0,
          position: 'fixed',
          top: headerElement.height() - yOffset,
          paddingRight: GLOBAL_PADDING_SIDE * 2,
          width: window.innerWidth
        });

        skipToContent.css({
          left: 0,
          position: 'fixed',
          top: headerElement.height() + flashRow.height() + GLOBAL_PADDING_SIDE - yOffset,
          paddingRight: GLOBAL_PADDING_SIDE,
          width: window.innerWidth
        });

        fixedElements.css({
          top: aboveTableHeight,
          position: 'fixed',
          width: '100%',
          zIndex: 2
        });

        tableAreaElement.css({
          'margin-top': fixedElements.height() + flashHeight - paddingSlop
        });

        tableFooterElement.css({
          position: 'fixed',
          width: tableAreaElement.width(),
          top: endOfTableHeight
        });

        if (uniqueHelpText.filter(":visible").length > 0) {
          const bottomOfTableFooter = tableFooterElement[0] ? tableFooterElement[0].getBoundingClientRect().bottom : 0;

          if (bottomOfTableFooter) {
            uniqueHelpText.css({
              position: 'fixed',
              top: bottomOfTableFooter
            });
          } else {
            uniqueHelpText.hide();
          }
        }

        if (canScrollY) {
          footerElement.css({
            top: fixedElements.height() + tableAreaElement.height() + flashHeight + aboveTableHeight + footerMarginTop,
            position: 'fixed'
          });
        } else {
          footerElement.css({
            top: 'inherit',
            position: 'fixed'
          });
        }
      }

      function resetElementsFromHorizontalScrolling() {
        $('#pageContentWrapper').css('padding-bottom', '');
        footerElement.css({
          top: 'inherit',
          position: ''
        });
      }

      function handleChange(e) {
        canScrollY = body.get(0).scrollHeight > window.innerHeight;
        if (e && e.originalEvent) {
          scrollDirection = setScrollDirection(e);
        }

        if (isIE) {
          positionElementsOnce();
        }

        if (scrollDirection.x) {
          closeOpenObjects();
        }

        positionElementsForHorizontalScrolling();
      }

      function handleDatePicker() {
        datepicker = $('.datepicker');
        datepicker.css({
          left: $(this).offset().left
        });

        datePickerInputs.blur();
      }

      function handleUserVoice() {
        if (typeof window.UserVoice !== 'undefined') {
          uservoice = $('.uv-popover');
          uservoice.fadeTo(0, 0);
          window.UserVoice.show();
          uservoice = $('.uv-popover');
          handleChange();
          uservoice.fadeIn(100);
        }
      }

      function closeOpenObjects() {
        if (scrollDirection.x) {
          $('.select2-drop').select2('close');
          datepicker.hide();
        }
      }

      function disableHorizontalScrolling() {
        removeListeners();
        resetElementsFromHorizontalScrolling();
      }

      this.off("beforeClose").on("beforeClose", disableHorizontalScrolling);
    }).call(this, fixedElements, elementToScroll);
  },

  render() {
    this.$el.html(this.template);
    this.$(".table-area").append(this.child("dataTable").render().$el);
    this.$("[data-mount=action-bar]").append(this.child("actionBar").render().$el);
    this.$(".insert-middle").append(this.insertMiddleTemplate);
    this._hideEditColumns();
    if (this.child("actionBar").isEmpty() || this.customActionBarTargetNode) {
      this.$('[data-mount=action-bar]').remove();
    }
    return this;
  },

  lock(state) {
    this.child("actionBar").lock(state);
    this.child("dataTable").lock("bulk", state);
    this.child("dataTable").lock("page", state);
    this.child("dataTable").lock("sort", state);
    this.child("dataTable").lock("filter", state);
    this.$(".table-area tbody td [data-mount='inline-edit']").toggle(!state);
    this.$(".table-area tbody td.column-actions button").prop("disabled", state);
  },

  enterEditMode(row, editControlsConfig) {
    if (editControlsConfig.beforeEdit && !editControlsConfig.beforeEdit(row.model)) {
      // config callback already has handled (or cancelled the edit, so don't pop inline edit)

    } else {
      this.lock(true);
      this._renderInlineEdit(row, editControlsConfig);
    }
  },

  exitEditMode() {
    const editControls = this.child("edit-controls");
    if (editControls) {
      editControls.close();
    }
    this.lock(false);
  },

  changeColumnVisibility(id, visibility, userInitiated) {
    const saveVisibility = this._settingsManager.saveOnVisibilityChanges;
    this._settingsManager.saveOnVisibilityChanges = saveVisibility || userInitiated;
    this.child("dataTable").columnVisibility(id, visibility);
    this._settingsManager.saveOnVisibilityChanges = saveVisibility;
  },

  changeColumnVisibilities(changes, userInitiated) {
    if (!_.isEmpty(changes)) {
      const saveVisibility = this._settingsManager.saveOnVisibilityChanges;
      this._settingsManager.saveOnVisibilityChanges = saveVisibility || userInitiated;
      this.child("dataTable").setColumnVisibilities(changes);
      this._settingsManager.saveOnVisibilityChanges = saveVisibility;
    } else {
      this._settingsManager.visibilityChange = true;
      this._settingsManager._saveColumnWidthChanges();
      this._settingsManager.visibilityChange = false;
    }
  },

  restoreDefaultDataTableSettings() {
    this._settingsManager.restoreDefaults();
  },

  getDefaultDataTableSettings() {
    return this._settingsManager.getDefaults();
  },

  restoreDefaultColumnWidths() {
    this._settingsManager.restoreDefaultColumnWidths();
  },

  renderTableRows() {
    const dataTable = this.child("dataTable");
    _.each(dataTable.children, row => {
      row.render();
    });
    dataTable._renderGrandTotalsRow();
  },

  _selectionsFromFragment(fragment) {
    const fragmentString = String(fragment);
    const fragmentParams = fragmentString.indexOf("?") === 0 ? fragmentString.substring(1) : "";
    const selections = Backbone.$.deparam(fragmentParams);
    const keys = this._keysFromHistoryFilters();
    return _.pick(selections, keys);
  },

  _keysFromHistoryFilters() {
    const allFilters = (this.filters || []).concat(this.multiSelectFilters);
    const historyFilters = _.where(allFilters, { history: true });
    const historyFiltersKeys = _.pluck(historyFilters, "attr");
    const historySelectFilters = _.filter(historyFilters, filter => filter.type === "select" && typeof filter.href !== 'undefined');
    const historySelectFiltersKeys = _.map(historySelectFilters, filter => `${filter.attr}_label`);

    return historyFiltersKeys.concat(historySelectFiltersKeys);
  },

  _createActionBar() {
    // eslint-disable-next-line new-cap
    this.child("actionBar", new this.actionBarClass({
      filters: this.filters,
      multiSelectFilters: this.multiSelectFilters,
      buttons: this.buttons,
      bulk: this.bulk,
      model: this.model,
      customActionBarTargetNode: this.customActionBarTargetNode
    }));
    // invoke provided bulk action handler with config and list of selected models
    this.listenTo(this.child("actionBar"), "bulk-action-selected", function(config, handler) {
      handler.call(this, config, this.child("dataTable").selectedModels());
    });
    this.on("changed:selections", function(params) {
      const keys = this._keysFromHistoryFilters();
      if (!_.isEmpty(keys)) {
        const filterParams = _.pick(params, keys);
        if (!_.isEmpty(filterParams)) {
          const fragments = this._extractUrlHistoryFragments();

          const filterParamsFromQueryString = $.extend($.deparam(fragments.afterQuestionMark), filterParams);
          Backbone.history.navigate(`${fragments.beforeQuestionMark}?${Backbone.$.param(filterParamsFromQueryString)}`, { trigger: false, replace: true });
        }
      }

      // hide any popovers left floating around by inline dropdowns in action_table rows
      $('.popover').each(function() {
        $(this).hide();
      });
    });
  },

  _extractUrlHistoryFragments() {
    let beforeQuestionMark = '';
    let afterQuestionMark = '';

    if (Backbone.history.fragment) {
      const parts = Backbone.history.fragment.split("?");
      beforeQuestionMark = _.isEmpty(parts[0]) ? "" : parts[0];
      afterQuestionMark = _.isEmpty(parts[1]) ? "" : parts[1];
    }

    return { beforeQuestionMark, afterQuestionMark };
  },

  _createDataTable(collection) {
    let DataTableClass = this.dataTableClass;
    if (this.pageLength) {
      DataTableClass = DataTableClass.extend({ paginateLength: this.pageLength });
    }
    this.child("dataTable", new DataTableClass({
      collection
    }));
    // notify the action bar of changes in bulk selection of rows and update stats
    this.listenTo(this.child("dataTable"), "change:selected", function(data) {
      this.child("actionBar").lockBulkSelect(data.count === 0);
      this._updateBulkSelectionStats(data.count);
    });
    // populate initial selections
    this._updateDataTableAjaxParams();
    this.on("change:selections", this._updateDataTableAjaxParams);
  },

  _updateDataTableAjaxParams() {
    // since the dataTable's ajax request doesn't run through InvocaSync, we add the ajax flag manually
    const newParams = _.extend({ ajax: 1 }, this.model.toJSON());
    const oldParams = this.child("dataTable").serverParams();
    if (!_.isEqual(newParams, oldParams)) {
      this.child("dataTable").serverParams(newParams);
      this.trigger("changed:selections", _.omit(newParams, 'ajax'));
    }
  },

  // Hide 'Edit Columns' when we have columnGroupDefinitions, aka header groups for compare time periods
  _hideEditColumns() {
    if (this._columnGroupDefinitionDefined()) {
      this.$(".edit-columns").hide();
    }
  },

  _columnGroupDefinitionDefined() {
    return !_.isEmpty(this.child("dataTable").rowClass.prototype.columnGroupDefinitions);
  },

  _bulkEnabled() {
    if (this.bulk) {
      return this._hasBulkActions();
    } else {
      return false;
    }
  },

  _hasBulkActions() {
    const actions = this.bulk.actions;
    const visibleActions = _.select(actions, config => !config.present || config.present());

    return !_.isEmpty(visibleActions);
  },

  _updateBulkSelectionStats(selectedCount) {
    if (!this._bulkEnabled()) { return; }
    let text;
    const objectName = this.child("dataTable").objectName;
    const totalCount = this.child("dataTable").totalRecordsCount();
    if (selectedCount === 0) {
      text = `No ${objectName.plural} selected.`;
    } else {
      text = `Bulk actions will apply to ${selectedCount} of ${totalCount} ${objectName.plural} selected.`;
    }
    this.$(".bulk-actions-stats").text(text);
  },

  _editableInputClass(type) {
    if (type === "text") {
      return EditableTextInputView;
    } else if (type === "select") {
      return EditableSelectInputView;
    } else {
      throw new Error(`Invalid input type ${type}`);
    }
  },

  _buildEditables(row, cells, model) {
    // for every editable column, find the cell where it needs to be rendered and create instance
    const inputNodePairs = [];
    _.each(row.columnsConfig, function(config) {
      if (config.editable) {
        // TODO - enforce that an attr is there for an editable column
        const Klass = this._editableInputClass(config.editable.type);
        const inputOpts = _.extend({ model, attr: config.attr }, config.editable);

        inputNodePairs.push({
          node: cells.filter(config.nodeMatcher(config)),
          input: new Klass(inputOpts)
        });
      }
    }, this);
    return inputNodePairs;
  },

  _processErrors(response, editableInputs) {
    if (response.responseJSON) {
      this._displayErrors(response.responseJSON.errors, editableInputs);
    } else {
    }
  },

  _clearErrors(editableInputs) {
    const editControls = this.child("edit-controls");
    editControls && editControls.displayErrors({});
    _.each(editableInputs, input => {
      input.$el.removeClass("has-error");
    });
  },

  _displayErrors(errors, editableInputs) {
    if (!_.isEmpty(errors)) {
    } else {
      // use generic error message when no errors present
      errors = { base: ["Sorry, an error occurred"] };
    }

    // display actual error messages
    const editControls = this.child("edit-controls");
    editControls && editControls.displayErrors(errors);

    // add error indicators to all columns with an attribute containing an error
    _.each(editableInputs, editableInput => {
      errors[editableInput.attr] && editableInput.$el.addClass("has-error");
    });
  },

  _onEditClick(event) {
    event.preventDefault();
    const row = $(event.target).closest("tr").data("row");

    let editControlsConfig = _.find(row.columnsConfig, config => !!config.edit);
    if (_.isObject(editControlsConfig)) {
      editControlsConfig = editControlsConfig.edit;
    } else {
      editControlsConfig = {};
    }

    this.enterEditMode(row, editControlsConfig);
  },

  _renderInlineEdit(row, config) {
    const self = this;
    const cells = row.findCells();
    const editModel = row.model.clone();
    const editableNodeInputPairs = this._buildEditables(row, cells, editModel);
    const editableInputs = _.pluck(editableNodeInputPairs, "input");
    const editControls = new EditableControls(_.extend({ row, editModel }, config)).render();

    this.child("edit-controls", editControls);
    _.each(editableNodeInputPairs, item => {
      if (item.node.length === 1) {
        // store the editable input as a child of the controls
        editControls.child(`editable-${item.input.cid}`, item.input);
        item.node.empty().append(item.input.render().$el);
      } else if (item.node.length > 1) {
        throw new Error("no more than one node must be matched");
      }
    });

    // stop effects of the cells so no temporary value gets copied to editControls
    cells.stop(true, true);

    this.listenTo(editControls, "cancel", function() {
      this.exitEditMode();
      row.render();
    });

    this.listenTo(editControls, "save", function(additionalData) {
      const editedAttrs = editModel.pick(_.pluck(editableInputs, "attr"));
      editControls.toggleSaving();
      this._clearErrors(editableInputs);
      // allow additional data to override the attributes that were edited or add new
      row.model.save(_.extend(editedAttrs, additionalData || {}), {
        wait: true,
        success(model, response, options) {
          self.exitEditMode();
          row.render();
          self._highlightRow(row);
          const redirect = options.xhr.getResponseHeader("X-Redirect");
          if (redirect) {
            window.location.href = redirect;
          }
        },
        error(model, response) {
          editControls.toggleSaving();
          self._processErrors(response, editableInputs);
        }
      });
    });

    row.$("[data-mount='inline-edit']").after(editControls.$el);
  },

  _onEditColumnsClick(event) {
    const modalColumnPicker = this.child("modalColumnPicker");
    modalColumnPicker && modalColumnPicker.close();
    this.child("modalColumnPicker", new ModalColumnPicker({ actionTable: this })).render();
    return false;
  },

  _handleColumnFilterEvents() {
    const self = this;
    this.child("dataTable").on("filter:column", () => {
      self._toggleClearFiltersLink();
    });
    self._toggleClearFiltersLink();
  },

  _onClearFiltersClick(event) {
    let table;
    let columnsConfig;
    table = this.child("dataTable");
    columnsConfig = table._columnManager.columnsConfig();
    $.each(columnsConfig, (index, column) => {
      const columnFilterView = table.children[`filter-${column.attr}`];
      if (columnFilterView) {
        columnFilterView.child("filter-menu").clear();
        this._toggleFilterToInactive(`.column-${column.attr.replace(".", "-")}`);
      }
    });

    table.updateAjaxSource();
    table.dataTable._fnAjaxUpdate();
  },

  _toggleFilterToInactive(columnClass) {
    this.$(`table thead th${columnClass} .DataTables_filter_wrapper span`).attr("class", "filterInactive");
  },

  // tagging the event in the events hash wasn't calling this the onclick function, so remove/add listener on visibility change
  _toggleClearFiltersLink() {
    const element = this.$("[data-action='clear-filters-area']");
    if (this.child("dataTable")._getFilteringSettings() !== "[]") {
      element.show();
      element.on("click", this._onClearFiltersClick.bind(this));
    } else {
      element.hide();
      element.off("click");
    }
  },

  _displayResetSortingLinkAndEvent() {
    const element = this.$("[data-action='reset-sorting-area']");
    if (this.currentTableSortingMatchesDefaultTableSorting()) {
      element.hide();
      element.off("click");
    } else {
      element.show();
      element.find('[data-action="reset-sorting"]').on("click", () => {
        this._settingsManager._resetSorting(this.child('dataTable'));
      });
    }
  },

  currentTableSortingMatchesDefaultTableSorting() {
    try {
      const defaultTableSortingColumn = this.child('dataTable').sorting.toString();
      const currentTableSortingColumn = this._settingsManager._sortingConfigMapping(this._settingsManager._getCurrentSettingsState().sorting).toString();

      return (defaultTableSortingColumn === currentTableSortingColumn);
    } catch (ex) {
      return false;
    }
  },

  _highlightRow(row) {
    const cells = row.findCells();
    cells.effect('highlight', { color: "#E0EFBD" }, 4000);
  },

  _highlightRowForId(rowId) {
    const highlightRow = _.find(this.child('dataTable').children, row => row.model && row.model.get("id") === rowId);

    if (highlightRow) {
      this._highlightRow(highlightRow);
    }
  },

  _highlightRowIfNecessary() {
    if (this.child('dataTable').highlightRowId) {
      this._highlightRowForId(this.child('dataTable').highlightRowId);
      this.child('dataTable').highlightRowId = null;
    }
  }
});

export default ActionTable;
